import MappSDK from '@atino/mapp-js-sdk';
const sdk = new MappSDK({ host: process.env.HOST || location.origin, local: true });
export default sdk;
